import { useFormik } from "formik";
import React, { useEffect } from "react";
import FormikInputGroup from "../../components/formik/FormikInputGroup";
import FormikSelectGroup from "../../components/formik/FormikSelectGroup";
import { useDispatch, useSelector } from "react-redux";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { getUsers, fetchUsers } from "../../app/reducers/Users/userSlice";
import { generateOptions } from "../../utils/Utils";
import { fetchGreyQualities } from "../../app/reducers/GreyQuality/greyQualitySlice";
import {
  fetchGreyPurchaseOrders,
  getGreyPo,
  updateGreyPurchaseOrder,
  reset,
} from "../../app/reducers/GreyPurchaseOrder/greyPOSlice";
import { useMemo } from "react";
import { useState } from "react";
import DangerButton from "../../components/infrastructure/Buttons/DangerButton";
import ImageComponent from "../../components/ImageComponent";
const inputStyle = {
  width: "137px",
  borderColor: "#e4e6fc",
  borderRadius: "7px",
};

const ReceivePurchaseOrder = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reset({}));
  }, []);

  useEffect(() => {
    dispatch(fetchUsers({ role: "manufacturer" }));
    dispatch(fetchGreyQualities());
  }, []);

  const { loading, users } = useSelector(getUsers);
  const { greyPO } = useSelector(getGreyPo);
  const [manufacturer, setManufacturere] = useState("");
  const greyPurchasedata = useMemo(
    () =>
      greyPO?.docs
        ? greyPO.docs.filter(
          (d) =>
            d.status != "completed" &&
            d.status != "settled" &&
            d.status != "direct"
        )
        : [],
    [greyPO]
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      manufacturer: manufacturer ? manufacturer : "",
      poData: greyPurchasedata
        ? greyPurchasedata.map((d) => {
          return {
            ...d,
            activate: false,
            receivedNew: 0,
            damaged: 0,
          };
        })
        : [],
    },
    onSubmit: async (values) => {
      formik.resetForm();
    },
  });
  useEffect(() => {
    formik.resetForm();
  }, []);

  // useEffect(() => {
  //   console.log(data,"check")
  //   if(!data.length && manufacturer){
  //     setTimeout(() => alert("Data Not Found"),500)
  //   }
  // },[manufacturer])

  const submitDetails = async (e, index) => {
    try {
      setIsSubmitting(true);
      e.preventDefault();
      let detail = formik.values.poData[index];
      let received = [
        {
          date: new Date(),
          receivedItem: detail.receivedNew,
          damagedItem: detail.damaged,
        },
      ];
      let data = {
        ...detail,
        received: [...detail.received, ...received],
        receivedNew: detail.receivedNew,
        damaged: detail.damaged,
      };
      await dispatch(updateGreyPurchaseOrder(data));
      await dispatch(
        fetchGreyPurchaseOrders({
          manufacturer: formik.values.manufacturer,
          populate: true,
        })
      );
      setManufacturere(manufacturer);
      formik.setFieldValue("manufacturer", formik.values.manufacturer);
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 500);
    }
  };
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Receive Purchase Order</h1>
      <br></br>
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
        <FormikSelectGroup
          formik={formik}
          label="Manufacturer"
          name="manufacturer"
          // value={formik.values.manufacturer}
          onChange={async (data) => {
            await dispatch(
              fetchGreyPurchaseOrders({
                manufacturer: data.value,
                populate: true,
              })
            );
            setManufacturere(data.value);
            formik.setFieldValue("manufacturer", data.value);
            // if(!greyPurchasedata.length){
            //   alert("Data Not Found")
            // }
          }}
          required
          options={generateOptions({
            array: users ? users.docs : [],
            valueField: "_id",
            labelField: "name",
          })}
        />
        {/* border-collapse border border-slate-1000 table-auto w-full divide-y divide-slate-400 */}
        <div className="relative overflow-x-auto">
          <table
            className="table-auto w-full border text-center"
            style={{ padding: "10px" }}
          >
            <thead className="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200 p-2">
              <th scope="col" style={{ padding: "15px" }}>
                SRNO
              </th>
              <th scope="col" style={{ width: "170px" }}>
                Photo
              </th>
              <th scope="col">Grey Quality</th>
              <th scope="col">Grey Color</th>
              <th scope="col">Location</th>
              <th scope="col">Unit</th>
              <th scope="col">Ordered Total</th>
              <th scope="col">Ordered Remaining</th>
              <th scope="col">Received</th>
              <th scope="col">Damaged</th>
              <th scope="col">Action</th>
            </thead>
            {formik.values.poData &&
              formik.values.poData.length > 0 &&
              formik.values.poData.map((grey, index) => (
                <>
                  <tbody className="text-sm divide-y divide-slate-200">
                    <td>{index + 1}.</td>
                    <td className="p-3">
                      <div
                        style={{
                          width: "170px",
                          height: "auto",
                          padding: "10px",
                        }}
                      >
                        {grey?.greyColorData?.image && (
                          <ImageComponent src={grey?.greyColorData?.image} />
                          // <img src={grey?.greyColorData?.image} />
                        )}
                      </div>
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={grey?.greyData?.name}
                        name={`greyQuality.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={grey?.greyColorData?.color}
                        name={`greyQuality.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={grey?.locationData?.name}
                        name={`greyQuality.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={grey?.grey_unit}
                        name={`unit.${index}`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        formik={formik}
                        style={inputStyle}
                        value={grey?.quantity}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        formik={formik}
                        value={formik.values.poData[index]?.remaining}
                        style={inputStyle}
                        name={`poData.${index}.remaining`}
                        readOnly
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        min={0}
                        formik={formik}
                        style={{
                          width: "137px",
                          backgroundColor:
                            !formik.values.poData[index].activate &&
                            "#D8D8D880",
                          borderColor: "#e4e6fc",
                          borderRadius: "7px",
                        }}
                        max={
                          formik.values.poData[index].remaining -
                          formik.values.poData[index].damaged
                        }
                        disabled={!formik.values.poData[index].activate}
                        name={`poData.${index}.receivedNew`}
                      />
                    </td>
                    <td className="p-3">
                      <FormikInputGroup
                        type="number"
                        formik={formik}
                        min={0}
                        style={{
                          width: "137px",
                          backgroundColor:
                            !formik.values.poData[index].activate &&
                            "#D8D8D880",
                          borderColor: "#e4e6fc",
                          borderRadius: "7px",
                        }}
                        max={
                          formik.values.poData[index].remaining -
                          formik.values.poData[index].receivedNew
                        }
                        disabled={!formik.values.poData[index].activate}
                        name={`poData.${index}.damaged`}
                      />
                    </td>
                    <td className="p-3">
                      <div style={{ display: "flex", gap: "10px" }}>
                        {!formik.values.poData[index].activate && (
                          <PrimaryButton
                            onClick={() =>
                              formik.setFieldValue(
                                `poData.${index}.activate`,
                                true
                              )
                            }
                          >
                            Activate
                          </PrimaryButton>
                        )}
                        {formik.values.poData[index].activate && (
                          <>
                            <DangerButton
                              onClick={() =>
                                formik.setFieldValue(
                                  `poData.${index}.activate`,
                                  false
                                )
                              }
                            >
                              Deactivate
                            </DangerButton>
                            <PrimaryButton
                              disabled={isSubmitting}
                              onClick={(e) => submitDetails(e, index)}
                            >
                              Submit
                            </PrimaryButton>
                          </>
                        )}
                      </div>
                    </td>
                  </tbody>
                </>
              ))}
          </table>
        </div>
      </form>
    </div>
  );
};

export default ReceivePurchaseOrder;
